type Position = "secretary" | "headCoach" | "welfareOfficer" | "dbsVerifier";

interface ClubMemberDetails {
  [key: string]: any;
}

interface TransformedMember extends ClubMemberDetails {
  id: string;
  positions: Position[];
  priority: number;
}

const transformClubMembers = (
  clubData: Record<string, ClubMemberDetails>,
  staff: Record<string, Position[]>
): TransformedMember[] => {
  const positionOrder: Position[] = ["secretary", "headCoach", "welfareOfficer", "dbsVerifier"]

  return Object.entries(clubData).map(([id, details]) => {
    const positions = staff[id] || []

    const priority = Math.min(
      ...positions.map(pos => positionOrder.indexOf(pos)).filter(i => i !== -1),
      Infinity
    )

    return {
      id,
      positions,
      priority,
      ...details
    }
  })
}
export default transformClubMembers